class CartDrawer extends HTMLElement {
  #rendering = false;

  connectedCallback() {
    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });
  }

  open() {
    this.classList.remove('is-closing');
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.add('is-closing');
    window.setTimeout(() => {
      this.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('overflow-hidden');
    }, 125);
  }

  async renderCartContents(state) {
    if (this.#rendering) return;
    const sectionHtml = state?.sections?.[this.dataset.sectionId];
    if (!sectionHtml) return;
    this.#rendering = true;
    try {
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const next = parsed.querySelector('cart-drawer .cart-drawer__inner');
      const current = this.querySelector('.cart-drawer__inner');
      if (!next || !current) return;
      current.innerHTML = next.innerHTML;
      this.classList.toggle('cart-drawer--empty', Number(state.itemCount) === 0);
      const count = document.querySelector('cart-icon [data-ref="cart-count"]');
      if (count && typeof state.itemCount === 'number') count.textContent = state.itemCount;
    } finally {
      this.#rendering = false;
    }
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItem extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('change', this.#onChange);
  }

  #onClick = (event) => {
    const remove = event.target.closest('[data-ref="remove-item"]');
    if (!remove) return;
    event.preventDefault();
    this.#change(0);
  };

  #onChange = (event) => {
    if (!event.target.matches('[data-ref="quantity-selector-input"]')) return;
    this.#change(Math.max(1, Number(event.target.value || 1)));
  };

  async #change(quantity) {
    const drawer = this.closest('cart-drawer');
    if (!drawer) return;
    this.classList.add('cart-drawer__item--loading');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(this.dataset.index),
          quantity,
          sections: drawer.dataset.sectionId,
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || 'Impossible de mettre le panier à jour.');
      await drawer.renderCartContents({ itemCount: state.item_count, sections: state.sections });
    } catch (error) {
      console.error(error);
    } finally {
      this.classList.remove('cart-drawer__item--loading');
    }
  }
}

if (!customElements.get('cart-drawer-item')) customElements.define('cart-drawer-item', CartDrawerItem);
